module.exports = __webpack_public_path__ + "img/sg1.21a4adaf.png";